const loupeGreyIcon = `
<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17">
  <g fill="none" fill-rule="evenodd" transform="translate(-1 -1)">
    <rect width="19.2" height="19.202" x=".001"/>
    <path fill="#C9CCCD" fill-rule="nonzero" d="M16.5648,15.4328 L12.248,11.1168 C13.0912,10.0328 13.5984,8.6752 13.5984,7.1984 C13.5984,3.6696 10.7272,0.7984 7.1984,0.7984 C3.6696,0.7984 0.7984,3.6696 0.7984,7.1984 C0.7984,10.728 3.6696,13.5984 7.1984,13.5984 C8.6752,13.5984 10.0328,13.0912 11.116,12.248 L15.4328,16.5648 L16.5648,15.4328 Z M7.1992,11.9984 C4.552,11.9984 2.3992,9.8456 2.3992,7.1984 C2.3992,4.552 4.552,2.3984 7.1992,2.3984 C9.8464,2.3984 11.9992,4.552 11.9992,7.1984 C11.9992,9.8456 9.8464,11.9984 7.1992,11.9984 Z" transform="translate(.8 .8)"/>
  </g>
</svg>
`;

export default loupeGreyIcon;
